const STORAGE_KEY = 'haircutter_reservations';
const SETTINGS_KEY = 'haircutter_settings';

export const loadReservations = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error loading reservations:', error);
    return {};
  }
};

export const saveReservations = (reservations) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(reservations));
  } catch (error) {
    console.error('Error saving reservations:', error);
  }
};

export const loadSettings = () => {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    return stored ? JSON.parse(stored) : {
      startHour: 9,
      endHour: 18
    };
  } catch (error) {
    console.error('Error loading settings:', error);
    return { startHour: 9, endHour: 18 };
  }
};

export const saveSettings = (settings) => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving settings:', error);
  }
};

export const generateTimeSlots = (startHour = 9, endHour = 18, existingReservations = {}) => {
  const slots = [];
  
  // Calculate the actual end hour for the loop
  // If endHour is 0, treat it as 24 (midnight)
  const actualEndHour = endHour === 0 ? 24 : endHour;
  
  // Generate time slots for each hour from startHour to endHour
  for (let hour = startHour; hour < actualEndHour; hour++) {
    slots.push(`${hour.toString().padStart(2, '0')}:00`);
    slots.push(`${hour.toString().padStart(2, '0')}:30`);
  }
  
  // If endHour is 24 or 0 (midnight), add the final 00:00 slot
  if (actualEndHour === 24) {
    slots.push('00:00');
  }

  // Add any existing reservation time slots that are not already in the current schedule
  if (existingReservations && Object.keys(existingReservations).length > 0) {
    Object.keys(existingReservations).forEach(timeSlot => {
      if (!slots.includes(timeSlot)) {
        slots.push(timeSlot);
      }
    });
  }

  // Sort all time slots chronologically
  return slots.sort((a, b) => {
    const [aHour, aMin] = a.split(':').map(Number);
    const [bHour, bMin] = b.split(':').map(Number);
    
    // Convert to minutes for easy comparison
    const aMinutes = aHour * 60 + aMin;
    const bMinutes = bHour * 60 + bMin;
    
    return aMinutes - bMinutes;
  });
};

export const searchReservations = (reservations, searchTerm, selectedDate) => {
  if (!searchTerm) return {};
  
  const lowerSearchTerm = searchTerm.toLowerCase();
  const results = {};
  
  // Search in selected date
  if (reservations[selectedDate]) {
    Object.entries(reservations[selectedDate]).forEach(([timeSlot, reservation]) => {
      if (reservation.clientName.toLowerCase().includes(lowerSearchTerm)) {
        if (!results[selectedDate]) results[selectedDate] = {};
        results[selectedDate][timeSlot] = reservation;
      }
    });
  }
  
  // Search in all dates if no results in selected date
  if (Object.keys(results).length === 0) {
    Object.entries(reservations).forEach(([date, dayReservations]) => {
      Object.entries(dayReservations).forEach(([timeSlot, reservation]) => {
        if (reservation.clientName.toLowerCase().includes(lowerSearchTerm)) {
          if (!results[date]) results[date] = {};
          results[date][timeSlot] = reservation;
        }
      });
    });
  }
  
  return results;
};